import { render, staticRenderFns } from "./DescTxt.vue?vue&type=template&id=5a9ee456&scoped=true&"
import script from "./DescTxt.vue?vue&type=script&lang=js&"
export * from "./DescTxt.vue?vue&type=script&lang=js&"
import style0 from "./DescTxt.vue?vue&type=style&index=0&id=5a9ee456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9ee456",
  null
  
)

export default component.exports